import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";

export default function NotFoundPage() {
  const { t, to } = useLang();
  return (
    <section className="container-x flex min-h-[70vh] flex-col items-start justify-center pt-24" data-testid="not-found-page">
      <p className="font-mono text-sm text-teal-700">404</p>
      <h1 className="mt-4 font-display text-4xl font-extrabold text-slate-900 sm:text-5xl">{t.notFound.title}</h1>
      <p className="mt-4 text-slate-600">{t.notFound.text}</p>
      <Link to={to("home")} className="btn-primary mt-8" data-testid="not-found-home-link">{t.common.backHome}</Link>
    </section>
  );
}
